/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './back-button.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../../app/modules/layout/components/back-button/back-button.component';
import * as i3 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i4 from '@angular/material';
import * as i5 from '@angular/cdk/platform';
import * as i6 from '@angular/common';
const styles_BackButtonComponent:any[] = [i0.styles];
export const RenderType_BackButtonComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_BackButtonComponent,data:{}});
export function View_BackButtonComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),5,'button',[['class',
      'mat-button'],['md-button','']],[[8,'disabled',0]],[[(null as any),'click']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:i2.BackButtonComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.clickBack()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i3.View_MdButton_0,i3.RenderType_MdButton)),i1.ɵdid(1,16384,(null as any),
      0,i4.MdPrefixRejector,[[2,i4.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(2,180224,(null as any),0,i4.MdButton,[i1.Renderer2,i1.ElementRef,
      i5.Platform,i4.FocusOriginMonitor],(null as any),(null as any)),i1.ɵdid(3,16384,
      (null as any),0,i4.MdButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵeld(4,0,(null as any),0,0,'i',[['class','left-arrow']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,
          0,['BACK'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(null as any),(_ck,
      _v) => {
    const currVal_0:any = (i1.ɵnov(_v,2).disabled || (null as any));
    _ck(_v,0,0,currVal_0);
  });
}
export function View_BackButtonComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-back-button',
      ([] as any[]),(null as any),(null as any),(null as any),View_BackButtonComponent_0,
      RenderType_BackButtonComponent)),i1.ɵdid(1,114688,(null as any),0,i2.BackButtonComponent,
      [i6.Location],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const BackButtonComponentNgFactory:i1.ComponentFactory<i2.BackButtonComponent> = i1.ɵccf('app-back-button',
    i2.BackButtonComponent,View_BackButtonComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL2xheW91dC9jb21wb25lbnRzL2JhY2stYnV0dG9uL2JhY2stYnV0dG9uLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92YXIvd3d3L2RuYXRhLWNlcmYtZnJvbnQtZW5kL3JlbGVhc2VzLzIwMjAwMzI2MTYxMjMzL3NyYy9hcHAvbW9kdWxlcy9sYXlvdXQvY29tcG9uZW50cy9iYWNrLWJ1dHRvbi9iYWNrLWJ1dHRvbi5jb21wb25lbnQudHMiLCJuZzovLy92YXIvd3d3L2RuYXRhLWNlcmYtZnJvbnQtZW5kL3JlbGVhc2VzLzIwMjAwMzI2MTYxMjMzL3NyYy9hcHAvbW9kdWxlcy9sYXlvdXQvY29tcG9uZW50cy9iYWNrLWJ1dHRvbi9iYWNrLWJ1dHRvbi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL2xheW91dC9jb21wb25lbnRzL2JhY2stYnV0dG9uL2JhY2stYnV0dG9uLmNvbXBvbmVudC50cy5CYWNrQnV0dG9uQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGJ1dHRvbiBtZC1idXR0b24gKGNsaWNrKT1cImNsaWNrQmFjaygpXCI+PGkgY2xhc3M9XCJsZWZ0LWFycm93XCI+PC9pPkJBQ0s8L2J1dHRvbj5cbiIsIjxhcHAtYmFjay1idXR0b24+PC9hcHAtYmFjay1idXR0b24+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO01BQUE7UUFBQTtRQUFBO1FBQWtCO1VBQUE7VUFBQTtRQUFBO1FBQWxCO01BQUEscURBQUE7TUFBQTtNQUFBLHNCQUFBO3VDQUFBLHNDQUFBO01BQUE7TUFBd0M7VUFBQSwwREFBMEI7VUFBQSxhQUFhOztJQUEvRTtJQUFBLFdBQUEsU0FBQTs7OztvQkNBQTtNQUFBO29DQUFBLFVBQUE7TUFBQTtJQUFBOzs7OyJ9



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/layout/components/back-button/back-button.component.ngfactory.ts